import React from "react";
import { connect } from "react-redux";
import {
  Button,
  Card,
  ChangesIcon,
  Dialog,
  Heading,
  Pane,
  Text,
} from "evergreen-ui";
import { getCurrency, getFormattedDate, getFormattedTime } from "../util";

const BookingTransactionsDialog = (props) => {
  const {
    isShown,
    showBookingTransactionsDialog,
    bookingTransactionsData,
    printReceipt,
  } = props;

  return (
    <Dialog
      isShown={isShown}
      title={"Transactions"}
      display={"flex"}
      hasFooter={false}
      onCloseComplete={() => showBookingTransactionsDialog(false)}
    >
      <React.Fragment>
        {bookingTransactionsData &&
          bookingTransactionsData["transactionDetails"].map(
            (transaction, index) => (
              <Card
                key={index}
                display={"flex"}
                flexDirection={"column"}
                padding={10}
                paddingTop={16}
                paddingBottom={transaction.amount ? 8 : 16}
                marginTop={10}
                border={"default"}
              >
                <Pane
                  display={"flex"}
                  justifyContent={"space-between"}
                  marginBottom={16}
                >
                  <Heading size={100}>
                    <b>Type</b>
                  </Heading>
                  <Text>{transaction.type}</Text>
                </Pane>
                <Pane
                  display={"flex"}
                  justifyContent={"space-between"}
                  marginBottom={16}
                >
                  <Heading size={100}>
                    <b>Timestamp</b>
                  </Heading>
                  <Pane
                    display={"flex"}
                    flexDirection={"column"}
                    alignItems={"flex-end"}
                  >
                    <Text>
                      {getFormattedDate(
                        transaction.timestamp,
                        "YYYY-MM-DD",
                        "ddd, Do MMM YYYY"
                      )}
                    </Text>
                    <Text>
                      {getFormattedTime(transaction.timestamp.split(" ")[1])}
                    </Text>
                  </Pane>
                </Pane>
                <Pane
                  display={"flex"}
                  justifyContent={"space-between"}
                  marginBottom={16}
                >
                  <Heading size={100}>
                    <b>Source / Handler</b>
                  </Heading>
                  <Pane
                    display={"flex"}
                    flexDirection={"column"}
                    alignItems={"flex-end"}
                  >
                    <Text>{transaction.place}</Text>
                    <Text>{transaction.handler}</Text>
                  </Pane>
                </Pane>
                <Pane display={"flex"} justifyContent={"space-between"}>
                  <Heading size={100}>
                    <b>Paid / Mode</b>
                  </Heading>
                  <Pane
                    display={"flex"}
                    flexDirection={"column"}
                    alignItems={"flex-end"}
                  >
                    <Text>{`${getCurrency()} ${transaction.amount}`}</Text>
                    <Text>
                      {transaction.mode !== "-" ? transaction.mode : null}
                    </Text>
                  </Pane>
                </Pane>
                {transaction.amount ? (
                  <Pane display={"flex"} justifyContent={"center"}>
                    <Button
                      appearance={"minimal"}
                      iconBefore={"changes"}
                      onClick={() => printReceipt(transaction.transactionId)}
                    >
                      Print Receipt
                    </Button>
                  </Pane>
                ) : (
                  <React.Fragment />
                )}
              </Card>
            )
          )}
      </React.Fragment>
    </Dialog>
  );
};

const mapStateToProps = ({ bookingTransactionsData }) => ({
  bookingTransactionsData,
});

export default connect(mapStateToProps)(BookingTransactionsDialog);
